export const glyMg = [
    {
        index: '2',
        name: '管理员管理',
        url: '/glyMg'
    },{
        index: '7',
        name: '门店管理',
        url: '/glyMd'
    },{
        index: '3',
        name: '用户统计',
        url: '/glyYhtj'
    },{
        index: '4',
        name: '营收统计',
        url: '/glyYstj'
    },{
        index: '5',
        name: '交易额统计',
        url: '/glyJye'
    },{
        index: '1',
        name: '添加内部业务员',
        url: '/glyNbmg'
    },{
        index: '6',
        name: 'Banner更新',
        url: '/glyBanner'
    }
]

export const shopMg = [
    {
        index: '2',
        name: '统计',
        url: '/a'
    },{
        index: '3',
        name: '团长申请',
        url: '/dlsOne'
    },{
        index: '4',
        name: '团长管理',
        url: '/dlsTwo'
    },{
        index: '5',
        name: '管理员管理',
        url: '/d'
    },{
        index: '6',
        name: '营收统计',
        url: '/e'
    }
]

export const nrMg = [
    {
        index: '1',
        name: '帮卖内容审核',
        url: '/bmOne'
    },{
        index: '2',
        name: '惠讯内容审核',
        url: '/hxOne'
    }
]

export const skYx = [
    {
        index: '1',
        name: '商品管理',
        url: '/goods'
    },{
        index: '2',
        name: '订单管理',
        url: '/order'
    }
]


// WEBPACK FOOTER //
// ./src/components/config.js